import React, { useEffect, useState } from 'react';
import { Grid, GridColumn as Column } from '@progress/kendo-react-grid';
import { Dimmer, Loader } from 'semantic-ui-react';
import { useCustomers } from '../../../providers/CustomerProvider';
import { AddButton } from '../../../components/AddButton/AddButton';
import phoneFormatter from 'phone-formatter';
import { useNavigate } from 'react-router';
import { useAuth } from '../../../providers/AuthenticationProvider';
const WEB_PAGE = 'Customers';

export const CustomerList = () => {
    const { customers, total, pageIndex, pageSize, sortState, setPageIndex, setPageSize, setSortState, queryCustomers } = useCustomers();
    const [loading, setLoading] = useState(true);
    const { checkAuth, getUserType, isSystemAdmin } = useAuth();
    const navigate = useNavigate();

    checkAuth(getUserType(), WEB_PAGE) && navigate('/');

    useEffect(() => {
        setLoading(true);
        const fetchCustomers = async () => {
            await queryCustomers();
            setLoading(false);
        }

        fetchCustomers();
    }, [pageSize, pageIndex, sortState, queryCustomers]);

    const handlePageChange = (e) => {
        setPageIndex(e.page.skip / e.page.take);
    };

    const handleSortChange = (e) => {
        setSortState(e.sort.length ? [{ fieldName: e.sort[0].field, dir: e.sort[0].dir }] : []);
    };

    const sort = sortState.map(s => ({ field: s.fieldName, dir: s.dir }));

    return (
        <div>
            <div className='pageHeader'>
                <h1>Customers</h1>
                {isSystemAdmin() && <AddButton to="/customers/create-customer">Create a Customer</AddButton>}
            </div>
            <div style={{ position: 'relative' }}>
                <Dimmer active={loading} inverted>
                    <Loader />
                </Dimmer>
                <Grid
                    data={customers}
                    total={total}
                    skip={pageIndex * pageSize}
                    take={pageSize}
                    pageable={true}
                    sortable={true}
                    sort={sort}
                    onPageChange={handlePageChange}
                    onSortChange={handleSortChange}
                    onRowClick={(e) => navigate(`/customers/edit/${e.dataItem.id}`)}
                >
                    <Column field="companyName" title="Company Name" />
                    <Column field="firstname" title="First Name" cell={props => <td>{props.dataItem.firstname ?? ''}</td>} />
                    <Column field="lastname" title="Last Name" cell={props => <td>{props.dataItem.lastname ?? ''}</td>} />
                    <Column
                        title="Address"
                        sortable={false}
                        cell={props => (
                            <td style={{ textAlign: 'left' }}>
                                <div>{props.dataItem.address_One}</div>
                                {props.dataItem.address_Two && <div>{props.dataItem.address_Two}</div>}
                                <div>{`${props.dataItem.city}, ${props.dataItem.state} ${props.dataItem.zip}`}</div>
                            </td>
                        )}
                    />
                    <Column
                        field="phone"
                        title="Contact Number"
                        cell={props => (
                            <td>{props.dataItem.phone ? phoneFormatter.format(props.dataItem.phone, '(NNN) NNN-NNNN') : 'N/A'}</td>
                        )}
                    />
                </Grid>
            </div>
        </div>
    );
};
